import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ViewPharmacyComponent } from "../../../../components/admin-dashboard-component/pharmacies/view-pharmacy-component/view-pharmacy-component";
@Component({
  selector: 'app-admin-view-pharmacy',
  standalone: true, 
  imports: [
    CommonModule,
    ViewPharmacyComponent
],
  templateUrl: './admin-view-pharmacy.html',
  styleUrl: './admin-view-pharmacy.scss',
})
export class AdminViewPharmacy {
}